// @flow

const FORM_WIDTH = 600;

const verifyPhoneHomeStyles = {
  container: (theme) => ({
    flexGrow: 1,
    width: '100%'
  }),

  formContainer: (theme) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    minHeight: '60vh'
  }),

  formPaper: (theme) => ({
    width: '100%',
    maxWidth: `${FORM_WIDTH}px`,
    padding: theme.spacing(4),
    marginTop: theme.spacing(2),
    marginLeft: 'auto',
    marginRight: 'auto',
    textAlign: 'center',
    '& h3': {
      fontWeight: 600,
      marginBottom: theme.spacing(2)
    },
    '& p': {
      marginBottom: theme.spacing(3)
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '90vw',
      padding: theme.spacing(3),
      marginTop: theme.spacing(1)
    }
  }),

  phoneInputContainer: (theme) => ({
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
    width: '100%'
  }),

  readonlyPhoneContainer: (theme) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3)
  }),

  readonlyPhone: (theme) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  }),

  editButton: (theme) => ({
    marginLeft: theme.spacing(1)
  }),

  submitButton: (theme) => ({
    marginTop: theme.spacing(2),
    width: '100%',
    borderRadius: 4,
    fontWeight: 600,
    padding: theme.spacing(1.5, 4)
  }),

  codeInputContainer: (theme) => ({
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center'
  }),

  codeInput: (theme) => ({
    '& input': {
      ...theme.typography.h3,
      fontFamily: theme.typography.fontFamily,
      textAlign: 'center'
    }
  }),

  resendLink: (theme) => ({
    marginTop: theme.spacing(2),
    cursor: 'pointer',
    textDecoration: 'none',
    color: theme.palette.primary.main,
    '&:hover': {
      textDecoration: 'underline'
    }
  }),

  resendLinkDisabled: (theme) => ({
    pointerEvents: 'none',
    textDecoration: 'none',
    color: theme.palette.text.disabled,
    cursor: 'default'
  }),

  errorMessage: (theme) => ({
    color: theme.palette.error.main,
    marginBottom: theme.spacing(2),
    textAlign: 'center'
  })
};

export default verifyPhoneHomeStyles;